import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import RoundScreen from '../../../components/roundScreen';
import MultiHalfText from '../../../components/MultiHalfText';

export default function Page01({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<MultiHalfText first='Bottom Heavy / Core' second='Workout 09' mt={true} />
			<RoundScreen
				isNumbered={false}
				rounds={[
					[
						{
							header: '(A) Quads / Glutes',
							value: 'Air Squats w / (LB)',
						},
						{
							header: 'Sets / Reps',
							value: '5 x 15',
						},
						{
							header: 'ABS / Core',
							value: 'Russian Twists',
						},
						{
							header: 'Sec / Minutes',
							value: '1 min',
						},
					],
					[
						{
							header: '(A) Quads / Glutes',
							value: 'Sumo Squats w / (DB)',
						},
						{
							header: 'Sets / Reps',
							value: '5 x 12',
						},
						{
							header: 'ABS / Core',
							value: 'Bicycles',
						},
						{
							header: 'Sec / Minutes',
							value: '30 sec',
						},
					],
					[
						{
							header: '(A) Quads / Glutes',
							value: 'High Knees',
						},
						{
							header: 'Sets / Reps',
							value: '5 x 20',
						},
						{
							header: 'ABS / Core',
							value: 'Rests',
						},
						{
							header: 'Sec / Minutes',
							value: '...',
						},
					],
					[
						{
							header: '(A) Quads / Glutes',
							value: 'Knee Strike To Squat',
						},
						{
							header: 'Sets / Reps',
							value: '5 x 12',
						},
						{
							header: 'ABS / Core',
							value: 'Plank Crunches',
						},
						{
							header: 'Sec / Minutes',
							value: '30 sec',
						},
					],
					[
						{
							header: '(A) Quads / Glutes',
							value: 'Triple Pulse Squat w / (DB)or(KB)',
						},
						{
							header: 'Sets / Reps',
							value: '5 x 10',
						},
						{
							header: 'ABS / Core',
							value: 'Plank',
						},
						{
							header: 'Sec / Minutes',
							value: '1 min',
						},
					],
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
